import { useMemo } from "react";

import { DocumentFragment } from "@/__generated__/graphql";
import { DataView } from "@/components/organisms/DataView";
import { useConnectionSetup } from "@/hooks/useConnectionSetup";
import { Objects } from "@/objects";
import { State } from "@/state";

import {
  documentToThreadContext,
  DocumentsViewThreadActions,
} from "./DocumentsViewThreadActions";
import { usePrepareDataViewThread } from "../shared/dataViewThread.tools";

export function DocumentsView() {
  const dataViewMode = State(
    (store) => store.dataViewModes[store.activeAppView] ?? "table",
  );

  const {
    columns,
    rows,
    loading,
    totalCount,
    loadNext,
    networkStatus,
    deleteNodeButtonProps,
  } = useConnectionSetup({ appView: "documents" });

  const documentRows = rows as DocumentFragment[];
  const prepareThread = usePrepareDataViewThread(
    documentRows,
    documentToThreadContext,
  );

  const onCheckedRowsExtraActions = useMemo(
    () => (props: { checkedRowIds: string[]; clearSelection: () => void }) => (
      <DocumentsViewThreadActions {...props} onPrepareThread={prepareThread} />
    ),
    [prepareThread],
  );

  return (
    <DataView
      totalCount={totalCount}
      columns={columns}
      rows={documentRows}
      loadNext={loadNext}
      isLoading={loading}
      networkStatus={networkStatus}
      onCheckedRowsExtraActions={onCheckedRowsExtraActions}
      onCheckedRowsButtonsProps={[deleteNodeButtonProps]}
      viewMode={dataViewMode}
      onAddNew={() =>
        State.getState().pushToCommandStack({
          commandDefinitionId: "create-DocumentObject",
        })
      }
      placeholderRow={Objects.DocumentObject.placeholder}
      emptyState={{
        ReactIcon: Objects.DocumentObject.ReactIcon,
        title: "No documents yet",
        description:
          "Invoices, receipts and bills land here once they are uploaded or forwarded in.",
        actionLabel: "New document",
      }}
    />
  );
}
